<template>
  <v-app>
    <v-app-bar
      app
      color="white"
      height="100"
    >
      

      <v-toolbar-title class="d-none d-md-flex">
        <v-row>
          <v-col cols="12 mb-0 pb-0">
            <h2 class="font-weight-black">CIRCUITO DE PALESTRAS DE COMPUTAÇÃO</h2>
          </v-col>
          <v-col cols="12 pt-0 mt-0">
            <span class="text-md-subtitle-1 font-weight-bold"> IFRS - IBIRUBÁ/RS - 20 a 24/07/2020 e 27 a 31/07/2020</span>
          </v-col>
        </v-row>
         
      </v-toolbar-title>

      <v-toolbar-title class="d-flex d-sm-none d-none d-sm-flex d-md-none font-weight-black text-sm-body-1 headline">
        Circuito de Palestras<br>IFRS - Ibirubá
      </v-toolbar-title>
    
    
    
    </v-app-bar>

    <v-main>
      
      <v-sheet
        id="contact"
        color="#333333"
        dark
        tag="section"
        tile
      >
        <div class="py-12"></div>

        <v-container>
          <v-responsive class="mx-auto mb-12">
            <h4 class="text-md-h4 text-sm-body-2 text-lg-h4 font-weight-bold mb-3 text-uppercase text-center">Menu de Relatórios</h4>
          </v-responsive>


        <v-responsive>
          <v-row class="text-center">
            <v-col cols="12">
                <v-btn x-large outlined to="/listarinscritos" color="white"><v-icon large>mdi-file-document</v-icon> Listar Inscritos</v-btn>
            </v-col>
            <v-col cols="12">
                <v-btn x-large outlined to="/listarpresencas" color="white"><v-icon large>mdi-file-document</v-icon> Listar Comentários</v-btn>
            </v-col>
            <v-col cols="12">
                <v-btn x-large outlined to="/listarpresencasporpalestra" color="white"><v-icon large>mdi-file-document</v-icon> Listar Presenças por Palestra</v-btn>
            </v-col>
            <v-col cols="12">
                <v-btn x-large outlined to="/listarpresencasporusuario" color="white"><v-icon large>mdi-file-document</v-icon> Listar Presenças por Usuário</v-btn>
            </v-col>
            <v-col cols="12">
                <v-btn x-large outlined to="/listarpresencasporusuariodetalhado" color="white"><v-icon large>mdi-file-document</v-icon> Listar Presenças por Usuário Detalhado</v-btn>
            </v-col>
            <v-col cols="12">
                <v-btn x-large outlined to="/exportarCertificados" color="white"><v-icon large>mdi-file-document</v-icon> Exportar Dados p/ Certificados</v-btn>
            </v-col>
          </v-row>
        </v-responsive>
        </v-container>
      </v-sheet>
    </v-main>

    <v-footer
      class="justify-center"
      color="#292929"
      height="100"
    >
      <div class="title font-weight-light grey--text text--lighten-1 text-center">
        &copy; {{ (new Date()).getFullYear() }} — Computação - IFRS - Ibirubá
      </div>
    </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',
};
</script>
